// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GzHJ","col":"styles_col__1v4c0"};